import React, { memo, useEffect } from 'react';
import { APPLICATIONS_STAGES } from 'domain/recruiting/applications/shared/applicationService';
import QualificationCollapseHeader from 'domain/recruiting/applications/List/GroupedApplicationList/ApplicationsCollapseHeader';
import { Box } from '@mui/material';
import ApplicationsDataGrid from 'domain/recruiting/applications/List/ApplicationsDataGrid';
import { useListContext } from 'framework/list';
import { isEqual } from 'lodash';
import useApplicationsSettings from 'domain/recruiting/applications/List/GroupedApplicationList/Settings/useApplicationsSettings';
import { Collapse } from 'framework/ui/mui-builder';

export interface GroupedApplicationListCollapseProps {
  stage: string;
  filter?: Dictionary<any>;
  search?: string;
}

const GroupedApplicationListCollapse = memo(
  ({ stage, filter: filterFromProps, search: searchFromProps = '' }: GroupedApplicationListCollapseProps) => {
    const { filterBy, filter, search, searchBy } = useListContext();
    const { toggle, collapseStates = {} } = useApplicationsSettings();

    useEffect(() => {
      if (filterFromProps && filterBy && !isEqual(filterFromProps, filter)) {
        filterBy(filterFromProps);
      }
      // Suppressed warnings because we only need to call useEffect callback only after updating filters
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterFromProps]);

    useEffect(() => {
      if (searchBy && !isEqual(searchFromProps, search)) {
        searchBy(searchFromProps);
      }
      // Suppressed warnings because we only need to call useEffect callback only after updating search string
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchFromProps]);

    return (
      <Collapse
        header={<QualificationCollapseHeader title={APPLICATIONS_STAGES[stage]} />}
        isExpanded={collapseStates[stage]}
        toggle={() => toggle(stage)}
        sx={{
          '& > .collapse-header-wrapper': {
            padding: '8px 0 8px 6px',
            '& h3': { fontSize: '14px' },
            '& .collapse-title-wrapper': {
              flexWrap: 'nowrap',
              paddingRight: '50px',
            },
            '& .collapse-title': {
              paddingTop: 0,
              width: 'auto',
            },
          },
          '&.collapse-wrapper--open > .collapse-header-wrapper .collapse-title-wrapper': {
            paddingTop: '0.5rem',
          },
        }}
      >
        <Box sx={{ minHeight: '100px', position: 'relative', pb: 2 }}>
          <ApplicationsDataGrid
            key={`applications-${stage}-collapse-table`}
            showTotal={false}
            hasStageField={false}
            isSmallTable
          />
        </Box>
      </Collapse>
    );
  },
);

export default GroupedApplicationListCollapse;
